exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lang-selector[data-v-0e29e7b8]{position:absolute;top:4px;right:4px}.btn-lang-selector[data-v-0e29e7b8],select[data-v-0e29e7b8]{font-size:2rem;padding:.5rem 1.2rem}select[data-v-0e29e7b8]{background-color:rgba(224,78,10,.667);color:#fff;border:0;border-radius:5%}", ""]);

// exports
